import { createContext, useContext, type ReactNode } from 'react';

import type { PainelDadosOutputType } from '../../../shared/dto';
import { painelApi } from '../api/painel.api';
import { type ApiError, useApiQuery } from './use-api';

interface PainelSnapshotContextValue {
  dados: PainelDadosOutputType | undefined;
  loading: boolean;
  error: ApiError | null;
  refetch: () => void;
}

const PainelSnapshotContext = createContext<PainelSnapshotContextValue | null>(null);

/** Snapshot bruto (`GET /painel`) buscado uma vez e compartilhado; cada tela deriva e filtra o próprio estado de `dados`. */
export function PainelSnapshotProvider({ children }: { children: ReactNode }) {
  // Mantém o valor anterior durante o refetch: selects e modais montados não perdem opções.
  const { data, loading, error, refetch } = useApiQuery(painelApi.obter, undefined, {
    keepPreviousData: true,
  });

  return (
    <PainelSnapshotContext.Provider value={{ dados: data, loading, error, refetch }}>
      {children}
    </PainelSnapshotContext.Provider>
  );
}

export function usePainelSnapshot() {
  const ctx = useContext(PainelSnapshotContext);
  if (!ctx) {
    throw new Error('usePainelSnapshot precisa estar dentro de <PainelSnapshotProvider>.');
  }
  return ctx;
}
